import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

// GET clinical observations (for pre-fill)
export const getClinicalObservation = async (appointmentId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/appointments/${appointmentId}/clinical-observations`,
      {
        headers: {
          "Authorization": `Bearer ${localStorage.getItem("token")}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching clinical observations:",
      error.response?.data || error.message
    );
    throw error;
  }
};

// POST clinical observations (save / update)
export const saveClinicalObservation = async (appointmentId, data) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/appointments/${appointmentId}/clinical-observations`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem("token")}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error saving clinical observations:",
      error.response?.data || error.message
    );
    throw error;
  }
};

// GET all treatment history for a patient (returning patients)
export const getTreatmentHistory = async (customerId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/patients/${customerId}/treatment-history`,
      { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching treatment history:", error.response?.data || error.message);
    throw error;
  }
};
